'use client'

import { Card, BlockStack, InlineStack, Button } from '@shopify/polaris'
import { SigmaSectionHeader } from '@/components/sigma/SigmaSectionHeader'
import { DashboardOrdersExportMenu, type DashboardExportSegment } from '@/components/dashboard/DashboardOrdersExportMenu'
import { useSigmaSurface } from '@/components/SigmaSurfaceProvider'

type Props = {
  shop: string | null
  host: string | null
  onExportAudit: (segment?: DashboardExportSegment) => void
  exportLoading?: boolean
  exportDisabled?: boolean
  showSkuCostHint?: boolean
  showCourierHint?: boolean
}

function dashQuery(shop: string | null, host: string | null, extra: Record<string, string>) {
  const p = new URLSearchParams()
  if (shop) p.set('shop', shop)
  if (host) p.set('host', host)
  for (const [k, v] of Object.entries(extra)) p.set(k, v)
  const qs = p.toString()
  return qs ? `?${qs}` : ''
}

export function DashboardQuickActions({
  shop,
  host,
  onExportAudit,
  exportLoading,
  exportDisabled,
  showSkuCostHint,
  showCourierHint,
}: Props) {
  const surface = useSigmaSurface()
  const isPortal = surface === 'portal'
  const navVariant = isPortal ? 'secondary' : 'tertiary'
  const dash = dashQuery(shop, host, {})
  const withTab = (tab: string) => dashQuery(shop, host, { tab })

  return (
    <Card>
      <BlockStack gap="300">
        <SigmaSectionHeader title="Quick actions" />
        <InlineStack gap="200" wrap>
          <DashboardOrdersExportMenu
            onExport={(seg) => onExportAudit(seg)}
            loading={exportLoading}
            disabled={exportDisabled}
            variant="primary"
          />
          <Button variant={navVariant} url={`/dashboard${withTab('analytics')}`}>
            Analytics tab
          </Button>
          <Button variant={navVariant} url={`/dashboard${withTab('couriers')}`}>
            Couriers tab
          </Button>
          <Button variant={navVariant} url={`/dashboard${withTab('areas')}`}>
            City insights
          </Button>
          {showSkuCostHint ? (
            <Button variant={navVariant} url={`/settings${dash}`}>
              SKU costs & settings
            </Button>
          ) : null}
          {showCourierHint ? (
            <Button variant={navVariant} url={`/integrations${dash}`}>
              Courier integrations
            </Button>
          ) : null}
        </InlineStack>
      </BlockStack>
    </Card>
  )
}
